import Service from '@ember/service';
import { copy } from '@dashboard/shared-ui/utils/clipboard';

/**
 * A wrapper around the clipboard util to make testing easier.
 */
export default class Clipboard extends Service {
  copy(...args) {
    return copy(...args);
  }
}